import { render, staticRenderFns } from "./CapitalStatistical.vue?vue&type=template&id=120aad10&scoped=true"
import script from "./CapitalStatistical.vue?vue&type=script&lang=js"
export * from "./CapitalStatistical.vue?vue&type=script&lang=js"
import style0 from "./CapitalStatistical.vue?vue&type=style&index=0&id=120aad10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120aad10",
  null
  
)

export default component.exports